module.exports = __webpack_public_path__ + "img/honor_bg2.7e131628.png";